<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm6 md4>
            <v-text-field disabled v-model="item.productName" label="Product Name"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6>
               <v-text-field disabled v-model="item.unit" label="Unit"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field type="number" v-model.number="item.quantity" label="Quantity"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field type="number" disabled v-model.number="item.rate" label="Product Rate"></v-text-field>
          </v-flex>
          
          <v-flex xs12 sm6 md4>
            <v-text-field type="text" disabled v-model.number="item.HSN_code" label="HSN Code"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              type="number"
              disabled
              v-model.number="item.taxableGST_rate"
              suffix="%"
              label="GST"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md4>
            <v-text-field type="number" disabled v-model.number="item.basicPrice" label="Basic Price"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field type="number" disabled v-model.number="item.GSTValue" label="GST Value"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              type="number"
              disabled
              v-model.number="item.totlePrice"
              label="Total Price"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md8>
            <v-textarea label="Remark" v-model="item.returnRemark"></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
      <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { json } from "body-parser";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  props: {
    buyerId: String,
    editedItem: {
      type: Object,
      default: function() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type : '',
          productUnit : '',
          returnRemark : '',
        };
      }
    }
  },
  data() {
    return {
      actaulQuantity : this.editedItem.quantity,
      item: this.editedItem,
      returnItem : JSON.parse(JSON.stringify(this.editedItem)),
      selectedProduct: {}
    };
  },
  watch: {
    editedItem(val) {
      this.item = this.editedItem;
      this.returnItem =  JSON.parse(JSON.stringify(this.editedItem))
      this.actaulQuantity = this.editedItem.quantity
    },
    "item.quantity": {
      handler(newVal, oldVal) {
        if(newVal != oldVal) {
          this.calculatePrices();
        }
      },
      deep: true
    }
  },
  created() {
    this.$bindAsArray("rate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("product", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  methods: {
    close() {
      this.$emit("closeAddItem");
    },
    // productChange(val) {
    //   this.selectedProduct = val;
    //   this.item.productId = val[".key"];
    //   this.item.HSN_code = val["HSN_code"];
    //   this.item.taxableGST_rate = val["taxableGST_rate"];
    // },
    calculatePrices() {
      this.item.basicPrice = Number.parseFloat(
        this.item.rate * this.item.quantity
      ).toFixed(2);
      this.item.GSTValue = Number.parseFloat(
        this.item.basicPrice * (parseFloat(this.item.taxableGST_rate)/100)
      ).toFixed(2);
      this.item.totlePrice = Number.parseFloat(
        Number.parseFloat(this.item.basicPrice) + Number.parseFloat(this.item.GSTValue)
      ).toFixed(2);


      this.returnItem.quantity = this.actaulQuantity - this.item.quantity;
      // console.log(this.returnItem.quantity)
      // console.log(">>>>")
      this.returnItem.basicPrice = Number.parseFloat(
        this.returnItem.rate * this.returnItem.quantity
      ).toFixed(2);
      this.returnItem.GSTValue = Number.parseFloat(
        this.returnItem.basicPrice * (parseFloat(this.returnItem.taxableGST_rate)/100)
      ).toFixed(2);
      this.returnItem.totlePrice = Number.parseFloat(
        Number.parseFloat(this.returnItem.basicPrice) + Number.parseFloat(this.returnItem.GSTValue)
      ).toFixed(2);
      this.item['changed'] = true;
    },
    save() {
      // this.selectedProduct = this.product[this.item.productId];
      // this.item.productName = this.selectedProduct.name;
      // this.item.GST_type = this.selectedProduct.GST_type;
      // this.item.productUnit = this.selectedProduct.unit;
      this.$emit('saveAddItem', this.item, this.returnItem)
      // this.reset()
    },
    reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        GST_type : "",
        productUnit : '',
      };
      this.returnItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        GST_type : "",
        productUnit : '',
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Buyers/InvoiceReturn/UpdateItem.vue